import { render, staticRenderFns } from "./withdrawalDetail.vue?vue&type=template&id=8db50eaa&scoped=true&"
import script from "./withdrawalDetail.vue?vue&type=script&lang=js&"
export * from "./withdrawalDetail.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalDetail.vue?vue&type=style&index=0&id=8db50eaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db50eaa",
  null
  
)

/* custom blocks */
import block0 from "./withdrawalDetail.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports